import moment from 'moment';
import React from 'react';
import { Component, Fragment } from 'react';
import 'bootstrap';

class CountDown extends Component {
  state = {
    timeLeft: {},
    difference: +new Date(`${this.props.date}`) - +new Date() > 0,
  };

  calculateTimeLeft = () => {
    // let year = new Date().getFullYear();
    const date = moment(this.props.date).format('YYYY-MM-DD');

    const difference = +new Date(`${date}`) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };
  componentDidMount() {
    this.setState({ timeLeft: this.calculateTimeLeft() });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.timeLeft !== this.state.timeLeft) {
      setTimeout(() => {
        this.setState({ timeLeft: this.calculateTimeLeft() });
      }, 1000);
    }
  }
  render() {
    const timerComponents = [];
    const { title } = this.props;
    timerComponents.push(
      <Fragment>
        <section
          id='offerboard-timeout-section'
          className='offerboard-timeout-section clearfix'
        >
          <div className=''>
            <div className='row'>
              <div className='col-lg-12 col-md-12 col-sm-12'>
                <div className='rightside-wrapper'>
                  <div className='clock-wrapper'>
                    <ul className='countdown-list'>
                      <h2>{title}</h2>
                      <li className='timer-item days'>
                        <strong>{this.state.timeLeft.days}</strong>
                        <small>days</small>
                      </li>

                      <li className='timer-item hours'>
                        <strong>{this.state.timeLeft.hours}</strong>
                        <small>hours</small>
                      </li>
                      <li className='timer-item mins'>
                        <strong>{this.state.timeLeft.minutes}</strong>
                        <small>mins</small>
                      </li>
                      <li className='timer-item seco'>
                        <strong>{this.state.timeLeft.seconds}</strong>
                        <small>sec</small>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Fragment>
    );

    return <div>{this.state.difference && timerComponents}</div>;
  }
}

export default CountDown;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/CountDown.js